import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import cx from 'classnames';
import url from 'url';

import * as AppContext from 'lib/app-context';
import { passwordRecoveryError } from 'lib/common/messages';
import { routerLocationShape } from 'lib/common/prop-types';

import Brand from 'models/brand';

import InputPassword from 'components/common/input/password';

const propTypes = {
  brand: PropTypes.instanceOf(Brand).isRequired,
  errors: PropTypes.instanceOf(Map).isRequired,
  appContext: PropTypes.string.isRequired,
  recoverPassword: PropTypes.func.isRequired,
  addMessage: PropTypes.func.isRequired,
  setErrors: PropTypes.func.isRequired,
  dismissError: PropTypes.func.isRequired,
  cleanupPasswordRecoveryState: PropTypes.func.isRequired,
  routerLocation: routerLocationShape.isRequired,
};

class PasswordRecoveryForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      password: '',
    };

    this.dismissError = this.dismissError.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(e) {
    e.preventDefault();
    e.stopPropagation();
    const { routerLocation } = this.props;
    const { password } = this.state;
    const { email, key: passwordResetToken } = url.parse(routerLocation.search, true).query;
    if (!email || !passwordResetToken) {
      this.props.addMessage(passwordRecoveryError);
      return;
    }
    if (!password || password.length < 8) {
      this.props.setErrors({ password: 'must be at least 8 characters' });
      return;
    }


    this.props.recoverPassword({
      email,
      password,
      passwordResetToken,
    });
  }

  componentWillUnmount() {
    this.props.cleanupPasswordRecoveryState();
  }

  dismissError(value) {
    this.props.dismissError({ error: value });
  }

  handleChange(value, e) {
    const newState = {};
    newState[value] = e.target.value;
    this.setState(newState);
  }

  render() {
    const buttonClasses = cx({
      'btn-block': true,
      'btn-primary': true,
      'text-center': true,
      'btn-bp': this.props.brand.isBestParking,
    });

    return (
      <form onSubmit={this.onSubmit} noValidate>
        <div className="row">
          <div className="col-xs-12">
            <h1 className="text-size-24 text-color-dark-slate text-weight-bold">
              CREATE A NEW PASSWORD
            </h1>
            <InputPassword
              display="Password"
              error={this.props.errors.get('password')}
              value="password"
              dismissError={this.dismissError}
              onChange={this.handleChange}
              showTip={this.props.appContext !== AppContext.MOBILE}
            />
          </div>
        </div>
        <div className="row margin-top-40">
          <div className="col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-2">
            <button className={buttonClasses} onSubmit={this.onSubmit}>
              SET PASSWORD
            </button>
          </div>
        </div>
      </form>
    );
  }
}

PasswordRecoveryForm.propTypes = propTypes;
export default PasswordRecoveryForm;
